import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import pick from 'lodash/pick';
import { reduxKey } from './constants';
import { logPageView } from './actions';
const actionHandlers = handleActions({
    [logPageView.toString()]: (state, { payload })=>{
        return _object_spread_props(_object_spread({}, state), {
            pageview: pick(payload, 'view', 'component', 'typeid', 'itemid')
        });
    }
}, {
    pageview: {}
});
export default {
    [reduxKey]: actionHandlers
};

//# sourceMappingURL=reducer.js.map